import { AnysealClient } from "@anyseal/api-client";

export const portalClient = new AnysealClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  surface: "portal",
  onAuthenticationExpired: () => window.dispatchEvent(new Event("anyseal:portal-auth-expired")),
});
